export const ENV_PROPS = {
  "env": "lts",
  "region": "",
  "project_id": ""
};
